import React from "react";


const EstadoCellRenderer = ({ value }) => {
    const Ativo = ({ text }) => {
        return (
            <div className="cell-status-containel">
                <div className="cell-status ativo">{text}</div>
            </div>
        )
    }
    const Inativo = ({ text }) => {
        return (
            <div className="cell-status-containel">
                <div className="cell-status inativo">{text}</div>
            </div>
        )
    }

    const Warning = ({ text }) => {
        return (
            <div className="cell-status-containel">
                <div className="cell-status warning">{text}</div>
            </div>
        )
    }

    const Danger = ({ text }) => {
        return (
            <div className="cell-status-containel">
                <div className="cell-status danger">{text}</div>
            </div>
        )
    }


    const Info = ({ text }) => {
        return (
            <div className="cell-status-containel">
                <div className="cell-status info">{text}</div>
            </div>
        )
    }

    if (value.toString() === "1") {
        return <Ativo text="Ativo" />
    } else if (value.toString() === "COMPLETED") {
        return <Ativo text="Pago" />
    } else if (value.toString() === "CONFIRMED") {
        return <Ativo text="Confirmado" />
    } else if (value.toString() === "CANCELED") {
        return <Inativo text="Expirado" />
    } else if (value.toString() === "0") {
        return <Inativo text="Inativo" />
    } else if (value.toString() === "RESERVED") {
        return <Ativo text="Reservado" />
    } else if (value.toString() === "PENDING") {
        return <Inativo text="Pendente" />
    } else if (value.toString() === "AVAILABLE") {
        return <Ativo text="Disponivel" />
    } else if (value.toString() === "SCHEDULE") {
        return <Info text="Agendado" />
    } else if (value.toString() === "SOLD OUT") {
        return <Danger text="Esgotado" />
    } else if (value.toString() === "PROCESS") {
        return <Warning text="Em Processo" />
    } else {
        return "erro"
    }

}

export default EstadoCellRenderer;